import {InsuranceCompanyConfig, InsuranceCompanyLogoRole} from '../models/insurance-company-config';
import {InsuranceCompanyCode} from '../../shared/models/insurance-company-code.enum';
import {env, isKIOSKPOLIS, isNestBank, isYANOSIK} from '../utils/utils';
import {RuntimeEnvironment} from '../../shared/enums/runtime-environment.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ConfigurationService} from '../services/impl/configuration/configuration.service';

export class InsuranceCompaniesConfig {

    private configurationService: ConfigurationService;

    get resourcesEndpoint(): string {
        if (isNotNullOrUndefined(this.configurationService.configuration)) {
            return this.configurationService.configuration.uiConfig.resourcesEndpoint;
        }
        return '';
    }

    constructor(configurationService: ConfigurationService) {
        this.configurationService = configurationService;
    }

    createConfig(): InsuranceCompanyConfig[] {
        return [
            {
                code: InsuranceCompanyCode.AXA_DIRECT,
                name: 'Axa',
                disabledInFilters: true,
                disabledInOffersProgressDialog: true
            },
            {
                code: InsuranceCompanyCode.BEESAFE,
                name: 'Beesafe',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/BEESAFE/V1/BEESAFE_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 116
                            }
                        }
                    }
                ],
            },
            {
                code: InsuranceCompanyCode.BENEFIA,
                name: 'Benefia',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/BENEFIA/V1/BENEFIA_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 132
                            }
                        }
                    }
                ]
            },
            {
                code: InsuranceCompanyCode.GENERALI,
                name: 'Generali',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/GENERALI/V1/GENERALI_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 87
                            }
                        }
                    }
                ]
            },
            {
                code: InsuranceCompanyCode.LINK4,
                name: 'LINK4',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/LINK4/V1/LINK4_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 145
                            }
                        }
                    }
                ],
                addressDataCode: InsuranceCompanyAddressDataCode.LINK_4
            },
            {
                code: InsuranceCompanyCode.MTU,
                name: 'mtu24.pl',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/MTU/V1/MTU24_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 132
                            }
                        }
                    }
                ],
                addressDataCode: InsuranceCompanyAddressDataCode.MTU_24
            },
            {
                code: InsuranceCompanyCode.PROAMA,
                name: 'Proama',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/PROAMA/V1/PROAMA_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 100
                            }
                        }
                    }
                ]
            },
            {
                code: InsuranceCompanyCode.TUZ,
                name: 'TUZ',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/TUZ/V1/TUZ_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 82
                            }
                        }
                    }
                ],
                addressDataCode: InsuranceCompanyAddressDataCode.TUZ
            },
            {
                code: InsuranceCompanyCode.UNIQA,
                name: 'UNIQA',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/UNIQA/V1/UNIQA_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 88
                            }
                        }
                    }
                ],
                requiresGetOffer: true,
            },
            {
                code: InsuranceCompanyCode.DIRECT,
                name: 'Direct',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/DIRECT/V1/DIRECT_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 119
                            }
                        }
                    }
                ]
            },
            {
                code: InsuranceCompanyCode.EUROINS,
                name: 'EUROINS',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/EUROINS/V1/EUROINS_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 168
                            }
                        }
                    }
                ]
            },
            {
                code: InsuranceCompanyCode.ERGO_HESTIA,
                name: 'Ergo Hestia',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/ERGO_HESTIA/V1/ERGO_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 91
                            }
                        }
                    }
                ],
                addressDataCode: InsuranceCompanyAddressDataCode.MTU_24,
                disabledInFilters: !isKIOSKPOLIS() && !isNestBank() && (!isYANOSIK() || env() === RuntimeEnvironment.PROD),
                disabledInOffersProgressDialog: !isKIOSKPOLIS() && !isNestBank() && (!isYANOSIK() || env() === RuntimeEnvironment.PROD)
            },
            {
                code: InsuranceCompanyCode.TRASTI,
                name: 'Trasti',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/TRASTI/V1/TRASTI_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 120
                            }
                        }
                    }
                ]
            },
            {
                code: InsuranceCompanyCode.OMINIMO,
                name: 'Ominimo',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/OMINIMO/V1/OMINIMO_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 140
                            }
                        }
                    }
                ],
                disabledInFilters: !isKIOSKPOLIS() && !isNestBank() && (!isYANOSIK() || env() === RuntimeEnvironment.PROD),
                disabledInOffersProgressDialog: !isKIOSKPOLIS() && !isNestBank() && (!isYANOSIK() || env() === RuntimeEnvironment.PROD)
            },
            {
                code: InsuranceCompanyCode.PEVNO,
                name: 'Pevno',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/PEVNO/V1/PEVNO_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 130
                            }
                        }
                    }
                ],
                disabledInFilters: !isKIOSKPOLIS() && !isNestBank() && (!isYANOSIK() || env() === RuntimeEnvironment.PROD),
                disabledInOffersProgressDialog: !isKIOSKPOLIS() && !isNestBank() && (!isYANOSIK() || env() === RuntimeEnvironment.PROD),
                requiresGetOffer: true,
            },
            {
                code: InsuranceCompanyCode.ALLIANZ,
                name: 'Allianz',
                logos: [
                    {
                        role: InsuranceCompanyLogoRole.OFFERS_PROGRESS_DIALOG,
                        image: {
                            src: `${this.resourcesEndpoint}/RESOURCES/TU/ALLIANZ/V1/ALLIANZ_LOGO.png`,
                            sizeDefinition: {
                                maxWidth: 160
                            }
                        }
                    }
                ],
                disabledInFilters: !isKIOSKPOLIS() || env() === RuntimeEnvironment.PROD,
                disabledInOffersProgressDialog: !isKIOSKPOLIS() || env() === RuntimeEnvironment.PROD
            }
        ]
    };
}

export enum InsuranceCompanyAddressDataCode {
    MTU_24 = 'MTU_24',
    LINK_4 = 'LINK_4',
    TUZ = 'TUZ'
}
